import { BUDGET_YEAR, MONTHS, POSTING_YEAR } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useGetInvoiceReportsChart } from "@/services";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  CREATED_BY,
  DATE_RANGE,
  END_DATE,
  INVOICE_STATUS,
  PAYMENT_STATUS,
  START_DATE,
} from "../consts";

const useBudgetExpenseChart = ({ filterData, selectedYearOption }: any) => {
  const labels = MONTHS;
  const [chartData, setChartData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Invoice",
        data: [],
        borderColor: "#FFDFBD",
        backgroundColor: "#FFDFBD",
        tension: 0.4,
        pointStyle: "circle",
        pointRadius: 6,
      },
      {
        label: "Payment",
        data: [],
        borderColor: "#BDD6FF",
        backgroundColor: "#BDD6FF",
        tension: 0.4,
        pointStyle: "circle",
        pointRadius: 6,
      },
      {
        label: "Reversal",
        data: [],
        borderColor: "#FFBDBD",
        backgroundColor: "#FFBDBD",
        tension: 0.4,
        pointStyle: "circle",
        pointRadius: 6,
      },
    ],
  });

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const currentFinanceYear = useSelector(
    (state: RootState) => state.currentData.currentFinanceYear
  );

  const {
    data: reportChartData,
    isLoading: isReportChartLoading,
    refetch: refetchChartData,
  } = useGetInvoiceReportsChart({
    data: {
      communityId: communityDetail?.communityId,
      vendorId: filterData?.vendorId ? filterData?.vendorId : [],
      ...(selectedYearOption == POSTING_YEAR ? {[POSTING_YEAR]: currentFinanceYear} : {[BUDGET_YEAR]: currentFinanceYear}),
      ...((filterData as any)?.[DATE_RANGE]
        ? {
            [START_DATE]: (filterData as any)?.[DATE_RANGE][START_DATE],
            [END_DATE]: (filterData as any)?.[DATE_RANGE][END_DATE],
          }
        : {}),
      ...((filterData as any)?.[INVOICE_STATUS]
        ? {
            [INVOICE_STATUS]: (filterData as any)?.[INVOICE_STATUS],
          }
        : {}),
      ...((filterData as any)?.[CREATED_BY]
        ? {
            [CREATED_BY]: (filterData as any)?.[CREATED_BY],
          }
        : {}),
      ...((filterData as any)?.[PAYMENT_STATUS]
        ? {
            [PAYMENT_STATUS]: (filterData as any)?.[PAYMENT_STATUS],
          }
        : {}),
    },
  });

  useEffect(() => {
    refetchChartData();
  }, [filterData]);

  useEffect(() => {
    if (reportChartData) {
      const paidInvoiceData = labels?.map((label: string) => {
        const match = reportChartData?.data?.paidInvoiceData?.find(
          (val: any) =>
            label?.toLowerCase() === val?.month?.substr(0, 3)?.toLowerCase()
        );
        return match ? match.totalInvoice : 0;
      });

      const postInvoiceData = labels?.map((label: string) => {
        const match = reportChartData?.data?.postInvoiceData?.find(
          (val: any) =>
            label?.toLowerCase() === val?.month?.substr(0, 3)?.toLowerCase()
        );
        return match ? match.totalInvoice : 0;
      });

      const reversalInvoiceData = labels?.map((label: string) => {
        const match = reportChartData?.data?.reversalInvoiceData?.find(
          (val: any) =>
            label?.toLowerCase() === val?.month?.substr(0, 3)?.toLowerCase()
        );
        return match ? match.totalInvoice : 0;
      });

      let _chartData = { ...chartData };
      _chartData = {
        labels: labels as any,
        datasets: [
          {
            ..._chartData["datasets"][0],
            data: postInvoiceData,
          },
          {
            ..._chartData["datasets"][1],
            data: paidInvoiceData,
          },
          {
            ..._chartData["datasets"][2],
            data: reversalInvoiceData,
          },
        ],
      };
      setChartData({ ..._chartData });
    }
  }, [reportChartData]);

  return {
    chartData,
    isReportChartLoading,
  };
};

export default useBudgetExpenseChart;
